/**
 * Render de Markdown con soporte para GitHub-flavored y links seguros.
 * Los enlaces que apuntan a /seccion/... son navegados con TanStack Router.
 */
import { useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useNavigate } from '@tanstack/react-router';
import { cn } from '@/lib/utils';

export function Markdown({ content, className }: { content: string; className?: string }) {
  const navigate = useNavigate();

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      const target = (e.target as HTMLElement).closest('a');
      if (!target) return;
      const href = target.getAttribute('href') ?? '';
      if (href.startsWith('/')) {
        e.preventDefault();
        navigate({ to: href });
      }
    },
    [navigate],
  );

  return (
    <div className={cn('prose-kb', className)} onClick={handleClick}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children, ...rest }) => (
            <a href={href ?? '#'} {...rest} target={href?.startsWith('http') ? '_blank' : undefined}>
              {children}
            </a>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
